import { defineLazyComponent } from "../defineLazyComponent";

/**
 * Async-loaded wrapper around MapMarker.vue, which pulls in maplibre-gl.
 * Always import this instead of MapMarker.vue directly, so the map
 * library stays in its own chunk and isn't included in the main bundle.
 *
 * No fallbacks: markers render inside the map, where `.reset-children` strips
 * the styling off anything we put there, and one error box per house would be
 * worse than a missing pin. Failed loads are still retried, reported through
 * app.config.errorHandler and covered by the stale chunk reload.
 */
export const MapMarkerAsync = defineLazyComponent(
  () => import("./MapMarker.vue"),
  { loadingComponent: null, errorComponent: null },
);
